module.exports = __webpack_public_path__ + "static/vienna-dcf856db9353518887bd4a1486930d0d.jpg";